import React, { useContext } from 'react';
import ModalLayout from 'components/ModalLayout';
import DeviceFullInfoState from './deviceFullInfoState/DeviceFullInfoState';
import DeviceFullInfoView from './components/DeviceFullInfoModal/DeviceFullInfoView';
import { DevicesContext, IDevicesContext } from 'modules/Devices/Devices/devicesState/devicesContext';

const DeviceFullInfoPage: React.FC = () => {
	const { setDeviceIDForFullInfo, deviceIDForFullInfo } = useContext<IDevicesContext>(DevicesContext);

	const handleClose = () => {
		setDeviceIDForFullInfo('');
	};

	return (
		<DeviceFullInfoState>
			<ModalLayout isVisible={!!deviceIDForFullInfo} setIsShowModal={handleClose}>
				<DeviceFullInfoView />
			</ModalLayout>
		</DeviceFullInfoState>
	);
};

export default DeviceFullInfoPage;
